import Footer from 'layout/footer';
import Header from 'layout/header';
import CheckoutPage from 'pages/checkout';
import OrderConfirmation from 'pages/orderconfirmation';
import React, { Fragment, useEffect, useState } from 'react';
import { Container, Row, Col, Card, Form, InputGroup, ListGroup, Button, Spinner, Image } from 'react-bootstrap';
import apiEndPoint from 'utils/apiEndPoint';
import { apiCall } from 'utils/httpClient';
import { failedMessage } from 'utils/httpClient';
import { loadFromLocalStorage } from 'utils/LocalStorageUtils';
import { isEmpty } from 'utils/utils';
import axios from 'axios';
function DomainSelection({ orderDetail, handleBackPage }) {

  useEffect(() => {
    console.log('orderDetail: ', orderDetail);

  }, [])

  const [pageShow, setPageShow] = useState(0);//0=domainSearch,1=selectedDomain,2=checkout, 3=confirmation
  const [donaunName, setDonaunName] = useState('');
  const [selectedDomain, setSelectedDomain] = useState({});
  const [isloading, setIsloading] = useState(false);
  const [aiMarketing, setAIMarketing] = useState(false);
  const [newDomainList, setNewDomainList] = useState([]);
  const [languageData, setLanguageData] = useState(null);
  const [orderCompleateData, setOrderCompleateData] = useState(null);
  const selectLang = loadFromLocalStorage("SELECTLANGUAGE");
  useEffect(() => {
    setLanguageData(selectLang?.language)
  }, [selectLang])
  async function handleSearcgDomain(domain_n) {
    // setDonaunName(domain)
    const domain = donaunName
    if (domain.length > 3) {
      setIsloading(true);
      let params = { domain: domain }
      const { data } = await apiCall("post", apiEndPoint.GETSUGGESTDOMAINLIST, params);
      if (data.status === 200) {
        setNewDomainList(data.data);
      } else {
        failedMessage(data.message);
      }
      setIsloading(false)
    }
  }

  async function handleSelectDomain(item) {

    try {
      let rate = 85.29;
      const response = await axios.get('https://open.er-api.com/v6/latest/USD');
      if (response?.data?.rates?.INR) rate = response?.data?.rates?.INR;

      const priceItem = item?.price * parseFloat(rate);

      const formattedPrice = priceItem.toFixed(2);  // "1688.35" as a string
      const priceAsNumber = parseFloat(formattedPrice);  // 1688.35 as a number if needed
      item['isPremium'] = true;
      item['inr_price'] = priceAsNumber;

      setDonaunName(item?.name)
      setSelectedDomain(item)
      setNewDomainList([])
    } catch (error) {
      console.error('Error fetching exchange rate:', error.message);
    }

  }
  async function handleBack() {
    setSelectedDomain({})
    handleSearcgDomain(donaunName)
    handleBackPage('form')
  }

  return (
    <Fragment>
      {(pageShow === 0 || pageShow === 1) ?
        <div>
          <div className="services-section mt-5">
            <div className="container text-center">
              <h3 className="animate__animated animate__bounce" style={{ fontFamily: 'quicksand', fontWeight: 600, textAlign: 'center', margin: 'auto' }}>
                {languageData?.domainSetup}
              </h3>
              <br />
              <p style={{ fontSize: 16, fontWeight: 600, maxWidth: 800, margin: 'auto', color: '#444' }}>
                {languageData?.choosingTheRightDomainNameIsTheFirstStep}
              </p>
            </div>
          </div> <br /> <br />
          <Container>
            <div className='text-end'><button style={{ fontSize: 13, background: '#06038d' }}
              className="btn play-btn"
            > <i class="fa fa-video" aria-hidden="true"></i>

              <span className='ml-1'> {languageData?.instructionVideo}</span>
            </button>{" "}</div> <br />
            <div className="p-4" style={{ border: '1px solid #ddd', borderRadius: '12px', minHeight: '300px' }}>
              <Row>
                <Col md={6}>
                  <h6>Select your domain :</h6>
                  <InputGroup className="mb-3">
                    <Form.Control
                      placeholder="Domain Name"
                      aria-label="Domain search"
                      // value={isEmpty(selectedDomain?.name) ? donaunName : selectedDomain?.name}
                      value={donaunName}
                      // onChange={(e) => { isEmpty(selectedDomain?.name) && handleSearcgDomain(e.target.value) }}
                      // onChange={(e) => { isEmpty(selectedDomain?.name) && setDonaunName(e.target.value) }}
                      onChange={(e) => { setDonaunName(e.target.value) }}
                    />
                    {!isEmpty(selectedDomain?.name) &&
                      <InputGroup.Text><Image
                        src='assets/images/icon/Checkmark.png'
                        style={{ cursor: 'pointer', width: '25px' }} // Add pointer cursor for clickable effect
                      /></InputGroup.Text>
                    }
                    <InputGroup.Text style={{ cursor: 'pointer' }} onClick={() => { !isEmpty(donaunName) && !isloading && handleSearcgDomain(donaunName) }} >{isloading ? <Spinner animation="border" size="sm" role="status" /> : '🔍 Search'} </InputGroup.Text>
                  </InputGroup>
                  {!isEmpty(selectedDomain?.name) &&
                    <div className="text-muted" style={{ fontSize: '14px', textAlign: 'justify' }} >
                      {!isEmpty(selectedDomain?.price) ?
                        `You have selected premium domain. you will be charged USD $${selectedDomain?.price} extra.`
                        :
                        'Congratulations! You are eligible for a free domain.'
                      }
                    </div>
                  }
                  {newDomainList.length > 0 &&
                    <Card>
                      <ListGroup variant="flush">
                        {newDomainList.map((item, i) => (
                          // !item?.available &&
                          <ListGroup.Item className="d-flex justify-content-between" key={i} >
                            <span style={{ cursor: 'pointer' }} onClick={() => handleSelectDomain(item)} >{item?.name}</span>
                            {item?.price > '9.03' ?
                              <span> <span className="badge bg-warning text-dark me-2">Premium</span>${item?.price}</span>
                              :
                              <span>Free</span>
                            }
                          </ListGroup.Item>
                        ))}
                        {/* <ListGroup.Item className="d-flex justify-content-between">
                    <span>Akhilnayak.in</span>
                    <span>Free</span>
                    </ListGroup.Item> */}
                      </ListGroup>
                    </Card>
                  }
                </Col>
                <Col md={1}></Col>
                <Col md={5}>
                  <h6>Add on :</h6> <br />
                  <Form.Check
                    type="checkbox"
                    checked={aiMarketing}
                    onClick={() => setAIMarketing(aiMarketing ? false : true)}
                    label={
                      <>
                        <div className='d-flex justify-content-between'>
                          <p>AI Marketing</p>
                          <p>Rs 5/day</p>
                        </div>
                        <div
                          className="text-muted"
                          style={{ fontSize: '14px', textAlign: 'justify' }}
                        >
                          Get cutting-edge AI-driven marketing designed to optimize and enhance your digital marketing strategy
                        </div>
                      </>
                    }
                  />
                </Col>
              </Row>
            </div> <br />
            <Button style={{ borderRadius: 50, width: 'fit-content', fontSize: 14, background: '#ff966a', color: '#000', fontWeight: 500 }}
              size='lg' onClick={() => handleBack(0)}>
              Back
            </Button>
            <Button
              style={{ marginLeft: 20, borderRadius: 50, width: 'fit-content', fontSize: 14, background: '#ff966a', color: '#000', fontWeight: 500 }}
              size='lg' onClick={() => !isEmpty(selectedDomain?.name) && setPageShow(2)}>
              Proceed
            </Button>
          </Container>
        </div>
        : pageShow === 2 ?
          <CheckoutPage setOrderCompleateData={setOrderCompleateData} setPageShow={setPageShow} selectedDomain={selectedDomain} aiMarketing={aiMarketing} orderDetail={orderDetail} />
          :
          <OrderConfirmation orderCompleateData={orderCompleateData} handleBack={handleBack} />
      }
    </Fragment>
  );
}

export default DomainSelection;
